import Vue from 'vue'
import moment from "moment"

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  const arr = value.split(' ')
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('truncate', function (value, limit) {
  return value.substring(0, limit)
})

Vue.filter('tailing', function (value, tail) {
  return value + tail
})

Vue.filter('time', function (value, is24HrFormat = false) {
  if (value) {
    const date = new Date(Date.parse(value))
    let hours = date.getHours()
    const min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
    if (!is24HrFormat) {
      const time = hours > 12 ? 'AM' : 'PM'
      hours = hours % 12 || 12
      return `${hours}:${min} ${time}`
    }
    return `${hours}:${min}`
  }
})

Vue.filter('date', function (value, fullDate = false) {
  value = String(value)
  const date = value.slice(8, 10).trim()
  const month = value.slice(4, 7).trim()
  const year = value.slice(11, 15)

  if (!fullDate) return `${date} ${month}`
  else return `${date} ${month} ${year}`
})

Vue.filter('month', function (val, showYear = true) {
  val = String(val)

  const regx = /\w+\s(\w+)\s\d+\s(\d+)./
  if (!showYear) {
    return regx.exec(val)[1]
  } else {
    return `${regx.exec(val)[1]} ${regx.exec(val)[2]}`
  }

})

Vue.filter('indonesian_day', function (value) {
  moment.locale('id')
  return moment(value).format('dddd');
})

Vue.filter('indonesian_date', function (value) {
  moment.locale('id')
  return moment(value).format('ll');
})

Vue.filter('indonesian_date_time', function (value) {
  moment.locale('id')
  return moment(value).format('lll');
})

Vue.filter('indonesian_time', function (value) {
  moment.locale('en-gb')
  return moment(value).format('LTS');
})

Vue.filter('indonesian_time_short', function (value) {
  moment.locale('en-gb')
  return moment(value).format('LT');
})

Vue.filter('indonesian_month_year', function (value) {
  moment.locale('id')
  return moment(value).format('MMMM YYYY');
})

Vue.filter('indonesian_from_now', function (value) {
  moment.locale('id')
  return moment(value).fromNow();
})

Vue.filter('indonesian_from_now_short', function (value) {
  moment.locale('id')
  return moment(value).fromNow(true);
})

Vue.filter('csv', function (value) {
  return value.join(', ')
})

Vue.filter('filter_tags', function (value) {
  return value.replace(/<\/?[^>]+(>|$)/g, '')
})

Vue.filter('k_formatter', function (num) {
  return num > 999 ? `${(num / 1000).toFixed(1)}k` : num
})

Vue.filter('indonesian_rupiah', function (number) {
  number = number.toString().replace('.',',');
  number = number.replace(/[^,\d]/g, '').toString();
  let split = number.split(',');
  let sisa = split[0].length % 3;
  let rupiah = split[0].substr(0, sisa);
  let ribuan = split[0].substr(sisa).match(/\d{3}/gi);

  if(ribuan){
    let separator = sisa ? '.' : '';
    rupiah += separator + ribuan.join('.');
  }

  rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
  return `Rp. ${rupiah}`;
})

Vue.filter('number_formatter', function (number) {
  number = number.toString().replace('.',',');
  number = number.replace(/[^,\d]/g, '').toString();
  let split = number.split(',');
  let sisa = split[0].length % 3;
  let rupiah = split[0].substr(0, sisa);
  let ribuan = split[0].substr(sisa).match(/\d{3}/gi);

  if(ribuan){
    let separator = sisa ? '.' : '';
    rupiah += separator + ribuan.join('.');
  }

  rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
  return `${rupiah}`;
})